import React, { Component } from 'react'
import { HashRouter as Router, Route } from 'react-router-dom';
import Consult from './Consult';
import ThankYou from './ThankYou';

export default class Index extends Component {
    render() {
        return (
            <Router>
              <Route exact path="/consult" component={Consult} />
              <Route exact path="/thankyou" component={ThankYou} />
          </Router>
        )
    }
}
